import React from 'react';

import { Avatar } from '@/components/ui/catalyst/avatar';
import { Tooltip } from '@/components/ui/v3/Tooltip';
import { useGetUserByIdQuery } from '@/services/api/userService';

interface UserAvatarProps {
  userId?: string | null;
  size?: 'sm' | 'md';
  showName?: boolean;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  userId,
  size = 'sm',
  showName = false,
}) => {
  const { data: user, isLoading } = useGetUserByIdQuery(userId || '', {
    skip: !userId,
  });

  const sizeClasses = size === 'sm' ? 'size-6' : 'size-8';

  // Generate initials from first and last name
  const getInitials = (firstName?: string, lastName?: string): string => {
    const first = firstName?.charAt(0)?.toUpperCase() || '';
    const last = lastName?.charAt(0)?.toUpperCase() || '';
    return first + last || 'S'; // 'S' for System if no initials
  };

  if (isLoading) {
    return (
      <div
        className={`rounded-full bg-gray-200 animate-pulse ${sizeClasses}`}
      />
    );
  }

  const initials = getInitials(user?.first_name, user?.last_name);
  const displayName = user ? `${user.first_name} ${user.last_name}` : 'System';

  const avatar = (
    <Avatar className={sizeClasses} initials={initials} alt={displayName} />
  );

  if (showName && user) {
    return (
      <div className="flex items-center gap-2">
        <Tooltip content={displayName}>{avatar}</Tooltip>
        <span className="text-sm font-medium text-gray-900">
          {user.first_name} {user.last_name}
        </span>
      </div>
    );
  }

  return <Tooltip content={displayName}>{avatar}</Tooltip>;
};
